import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useDeleteModelsMutation } from '../../../generated/graphql';
import styles from './DeleteModelsDialog.module.css';

type DeleteModelsDialogProps = {
    onClose: () => void,
    ids: string[],
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const DeleteModelsDialog = (props: DeleteModelsDialogProps) => {
    const { style, visible, ids, onClose } = props;
    const [error, setError] = useState('');
    const [deleteModels, deleteModelsResult] = useDeleteModelsMutation({
        variables: {
            id: ids[0],
            ids: ids
        }
    });
    const handleOnYesClick = () => {
        setError('');
        deleteModels()
            .then(res => onClose())
            .catch(err => setError(err.message || 'An error occurred while deleting the model.'));
    };

    return (
        <DialogBase
            title="Delete Models"
            type="YesNo"
            onYesClick={handleOnYesClick}
            visible={visible}
            onClose={onClose}
            className={styles.DeleteModelsDialog}
            isLoading={deleteModelsResult.loading}
            validationError={error}
            style={style}
            data-testid="DeleteModelsDialog">
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete these models?</p>
        </DialogBase>
    );
};

export default DeleteModelsDialog;